import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

export const SliderContainer = styled.div<any>`
  .rc-slider {
    position: relative;
    height: 16px;
    padding: 6px 0;
    width: 100%;
    -ms-touch-action: none;
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #bec4c4;
    height: 2px;
    margin-top: 1px;
  }

  .rc-slider-track {
    position: absolute;
    left: 0;
    height: 2px;
    border: 2px solid #f45334;
    background-color: #f45334;
  }

  .rc-slider-handle {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    cursor: pointer;
    cursor: -webkit-grab;
    margin-top: -22px;
    cursor: grab;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }

  .rc-slider-handle::after {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #f45334;
  }

  .rc-slider-handle:focus-visible::after {
    outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')};
    outline-offset: 2px;
  }

  .rc-slider-handle:focus-visible,
  .rc-slider-handle:focus {
    outline: none;
  }

  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging::after {
    box-shadow: 0 0 0 4px rgba(246, 117, 92, 0.3);
  }

  .rc-slider-handle:focus::after {
    outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')};
    outline-offset: 2px;
  }

  .rc-slider-handle:hover::after {
    border-color: #f5674c;
  }

  .rc-slider-handle:active::after {
    box-shadow: 0 0 4px rgba(246, 117, 92, 0.3);
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }

  .rc-slider-step {
    position: absolute;
    width: 100%;
    height: 4px;
    background: transparent;
  }
`;
